
































import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    components: {},
})
export default class Lnb extends Vue {
    movePage(pathName: string) {
        this.$router.push(`/${this.$i18n.locale}${pathName}`)
    }
}
